export enum Overflow {
  Auto = 'auto',
  Hidden = 'hidden',
  Scroll = 'scroll',
  Visible = 'visible',
}
